var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditUser = function SvgEditUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 53"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#F9FCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.975 32.771A16.26 16.26 0 0 1 26 30.667c2.917 0 5.655.764 8.026 2.104M29.5 23.667a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m7 2.333c0 5.799-4.701 10.5-10.5 10.5S15.5 31.799 15.5 26 20.201 15.5 26 15.5 36.5 20.201 36.5 26"
  })));
};
export default SvgEditUser;